import { render, staticRenderFns } from "./VoteAnswerQuestion.vue?vue&type=template&id=6201c568&scoped=true"
import script from "./VoteAnswerQuestion.vue?vue&type=script&lang=js"
export * from "./VoteAnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./VoteAnswerQuestion.vue?vue&type=style&index=0&id=6201c568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201c568",
  null
  
)

export default component.exports